import __ from "src/utils/Translations";

export enum EmploymentForm {
  B2B = "B2B",
  CONTRACT_OF_EMPLOYMENT = "CONTRACT_OF_EMPLOYMENT",
  SPECIFIC_TASK_CONTRACT = "SPECIFIC_TASK_CONTRACT",
  MANDATE_CONTRACT = "MANDATE_CONTRACT",
  INTERNSHIP = "INTERNSHIP",
  VOLUNTARY_WORK = "VOLUNTARY_WORK",
  AGENCY_CONTRACT = "AGENCY_CONTRACT",
  MANAGEMENT_CONTRACT = "MANAGEMENT_CONTRACT",
  BODY_LEASING = "BODY_LEASING",
}

export const getEmploymentFormLabels = (): Record<EmploymentForm, string> => ({
  [EmploymentForm.B2B]: __("B2B"),
  [EmploymentForm.CONTRACT_OF_EMPLOYMENT]: __("Umowa o pracę"),
  [EmploymentForm.SPECIFIC_TASK_CONTRACT]: __("Umowa o dzieło"),
  [EmploymentForm.MANDATE_CONTRACT]: __("Umowa zlecenie"),
  [EmploymentForm.INTERNSHIP]: __("Staż"),
  [EmploymentForm.VOLUNTARY_WORK]: __("Wolontariat"),
  [EmploymentForm.AGENCY_CONTRACT]: __("Umowa agencyjna"),
  [EmploymentForm.MANAGEMENT_CONTRACT]: __("Kontrakt menedżerski"),
  [EmploymentForm.BODY_LEASING]: __("Body leasing"),
});

export const getEmploymentFormOptions = () =>
  Object.entries(getEmploymentFormLabels()).map(([value, label]) => ({
    value: value as EmploymentForm,
    label,
  }));
